export enum StorageNamespace {
  detailsPage = 'hg-detail-page',
  searchResults = 'hg-search-results',
}
